import { makeStyles, Theme } from '@material-ui/core'

export const useFinancialDetailsInputStyles = makeStyles((theme: Theme) => ({
  resetValueButton: {
    cursor: 'pointer',
    ['&:hover']: {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))
